export const USER = 'user';
